// Events
import {
  COLLECTION_FILTER_OPTION_CHECK,
  COLLECTION_FILTER_OPTION_UNCHECK,
  COLLECTION_FILTER_SUBMIT,
  COLLECTION_FILTER_UPDATE,
  SHOW_FIT_OPTIONS,
} from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';

export default component(async (node, ctx) => {
  const { option = [], showFitOptions } = choozy(node);
  const options = [].concat(option);

  ctx.on(COLLECTION_FILTER_UPDATE, ({ countData, activeFilters }) => {
    if (countData !== null) return;

    const activeFitFilters = activeFilters.filter(([name]) => name === node.dataset.paramName);

    options.forEach((opt) => {
      opt.checked = !!activeFitFilters.find(
        ([name, value]) => name === opt.name && value === opt.value,
      );
    });
  });

  node.addEventListener('change', (e) => {
    if (e.target.nodeName !== 'INPUT') return;

    ctx.emit(
      e.target.checked ? COLLECTION_FILTER_OPTION_CHECK : COLLECTION_FILTER_OPTION_UNCHECK,
      null,
      `${e.target.name}_${e.target.value}`,
    );
    ctx.emit(COLLECTION_FILTER_SUBMIT);
  });

  if (showFitOptions) {
    showFitOptions.addEventListener('click', () => {
      ctx.emit(SHOW_FIT_OPTIONS, null, showFitOptions.dataset.showFitOptions);
    });
  }
});
